import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-no-header-panel-wrapper',
  templateUrl: './no-header-panel-wrapper.component.html',
  styleUrls: ['./no-header-panel-wrapper.component.scss'],
  standalone: true
})
export class NoHeaderPanelWrapperComponent extends FieldWrapper {
  @ViewChild('fieldComponent', { read: ViewContainerRef })
  fieldComponent: ViewContainerRef;
}
